import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { activateAccount, setAccountError, setAccountValidationParams } from '@app/actions/accountActions';
import { Loader, GradientSection } from '@app/components';
import RouterConstants from '@app/constants/router';
import SignUpConfirmSuccess from './SignUpConfirmSuccess';
import SignUpConfirmFail from './SignUpConfirmFail';

class SignUpConfirm extends React.Component {
  componentDidMount() {
    const {
      accountValidationParams, setAccountError, isLoggedIn, history,
    } = this.props;

    if (isLoggedIn) {
      history.push(RouterConstants.HOME);
    }

    const { email, idHash, token } = accountValidationParams;

    if (email && idHash && token) {
      const { activateAccount } = this.props;
      activateAccount({ email, idHash, token });
    } else {
      setAccountError({
        code: 9999,
        message: 'Confirmation link is incorrect',
      });
    }
  }

  componentWillUnmount() {
    const { setAccountError, setAccountValidationParams } = this.props;
    setAccountError(null);
    setAccountValidationParams({});
  }

  render() {
    const { error, isActivationCompleted } = this.props;

    return isActivationCompleted ? (
      <GradientSection>
        <Container>
          { error ? <SignUpConfirmFail error={error} /> : <SignUpConfirmSuccess /> }
        </Container>
      </GradientSection>
    ) : <Loader />;
  }
}

SignUpConfirm.propTypes = {
  activateAccount: PropTypes.func.isRequired,
  setAccountError: PropTypes.func.isRequired,
  setAccountValidationParams: PropTypes.func.isRequired,
  isActivationCompleted: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
  accountValidationParams: PropTypes.shape({
    email: PropTypes.string,
    idHash: PropTypes.string,
    token: PropTypes.string,
  }).isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

SignUpConfirm.defaultProps = {
  error: null,
};

const mapStateToProps = ({
  account: { error, accountValidationParams, details },
  user: { isLoggedIn },
  subscribe,
}) => ({
  error,
  accountValidationParams,
  isActivationCompleted: (details || {}).status === 'ACTIVE' || error,
  isLoggedIn,
  subscribe,
});

const mapDispatchToProps = {
  activateAccount,
  setAccountError,
  setAccountValidationParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpConfirm);

const Container = styled.div`
  margin: 0 10px;
  display: inline-block;
`;
